module.exports = __webpack_public_path__ + "static/media/1.b2ef18b8.svg";